module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/zh-hans/4-8d49afda04828289864127f6480d92bc.jpg";